<template>
  <ul
    v-if="isShowLinks"
    class="links"
  >
    <li
      v-for="(link, index) in links"
      :key="index"
      class="links__item"
    >
      <anchor-link
        v-bind="link"
        class="links__link"
      >
        {{ link.title }}
        <icon-new-window
          v-if="link.isTargetBlank"
          class="links__icon"
        />
      </anchor-link>
    </li>
  </ul>
</template>

<script>
import { globalHeaderLinks } from '@/mikan/_shared/types/vueTypes/globalHeaderLink';
import AnchorLink from '@/mikan/_shared/components/atoms/AnchorLink.vue';
import NewWindowAnchor from '@/mikan/_shared/components/molecules/NewWindowAnchor.vue';
import IconNewWindow from '@/mikan/_shared/components/atoms/icons/IconNewWindow.vue';

export default {
  components: {
    AnchorLink,
    NewWindowAnchor,
    IconNewWindow,
  },
  props: {
    links: globalHeaderLinks.def(() => []),
  },
  computed: {
    isShowLinks() {
      return Array.isArray(this.links) && this.links.length > 0;
    },
  },
};
</script>


<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';
@import '~@/mikan/_shared/base/mixins';

.links {
  $horizontal-gutter: 12px;
  $vertical-gutter: 8px;

  @include for-sp {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  @include for-tb-pc {
    display: flex;
    margin-right: -$horizontal-gutter;
  }

  &__item {
    font-size: $size-l;
    font-weight: bold;

    @include for-sp {
      border-bottom: 1px solid $color-white;

      &:nth-child(even) {
        border-left: 1px solid $color-white;
      }
    }

    @include for-tb-pc {
      border-bottom: none;

      &:nth-child(even) {
        border-left: none;
      }

      &:nth-child(n + 2) {
        margin-left: 30px - $horizontal-gutter * 2;
      }
    }
  }

  &__link {
    border-radius: 2px;
    color: $color-white;
    transition: background-color $transition-base;

    @include for-sp {
      display: block;
      padding: 16px;
    }

    @include for-tb-pc {
      padding: $vertical-gutter $horizontal-gutter;
    }

    @include is-pointer-device {
      &:hover {
        background-color: rgba($color-white, 0.15);
      }
    }
  }

  &__icon {
    font-size: 10px;
  }
}
</style>
